export class ConfigurationService {
    configurationPromise;
    configuration;

    async getConfiguration() {
        this.configurationPromise = this.configurationPromise || new Promise(async (resolve) => {
            if (!this.configuration) {
                let response = await fetch('/Configuration');

                this.configuration = await response.json();
            }

            resolve(this.configuration);
        });

        return this.configurationPromise;
    };
}

const configurationService = new ConfigurationService();

export default configurationService;